
import UIkit from 'uikit'
import { Component, Vue } from 'vue-property-decorator'

import BacBigButton from '../BacBigButton.vue'
import BacModal from '../BacModal.vue'
import BacButton from '../BacButton.vue'
import BacInput from '../BacInput.vue'
import { Http } from '../../lib/utils/Http'

@Component({
  components: {
    BacBigButton,
    BacModal,
    BacButton,
    BacInput
  }
})
export default class WildcardFriend extends Vue {
  wildcardEmail = ''

  openWildcardModal () {
    UIkit.modal('#wildcard-modal').show()
  }

  async saveWildcard () {
    await Http.request('/api/discount/wildcard', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: this.wildcardEmail })
    })
    UIkit.notification({
      message: 'Wildcard wurde erstellt, dein Freund kann sich nun registrieren!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}

